import { observable, action, toJS } from 'mobx'
import { message } from 'hljd'
import Api from '@api/hotel/UniqueInfo'
import { Modal } from 'hljd'
import isEqual from 'lodash/isEqual'

class Store {
  @observable editable = false

  @observable tags = ['', '']

  @observable prohibit = ['', '']

  tags_old = []

  @observable value = ''

  @observable overviewStatus

  @observable reason

  @observable openStatus = true
  @observable loading = false

  @action
  getUniqueInfo = async isfirst => {
    let {
      data: { content = [], status, reason }
    } = await Api.getUniqueInfo()
    !content[0] && (content[0] = '')
    !content[1] && (content[1] = '')
    this.tags = content
    this.tags_old = JSON.parse(JSON.stringify(content))
    this.overviewStatus = status
    this.reason = reason
    isfirst && (this.openStatus = !!content.filter(o => o).length)
  }

  @action
  changeTags = index => v => {
    // if (!this.editable) return
    this.tags[index] = v
    this.overviewStatus = '2'
  }

  @action
  save = async () => {
    const [tag0, tag1] = (this.tags = [
      this.tags[0].trim(),
      this.tags[1].trim()
    ])
    if (!tag0 && !tag1) {
      message.info('请至少填写一个特色')
      return
    }

    if (isEqual(toJS(this.tags), this.tags_old)) {
      message.info('请修改后再提交')
      return
    }

    if (this.tags[1] && !this.tags[0]) {
      Modal.error({
        content: '请填写特色一'
      })
      return
    }

    await this.prohibitCheck(0)(tag0)
    await this.prohibitCheck(1)(tag1)

    if (this.prohibit[0] || this.prohibit[1]) {
      return
    }

    const param = {
      content: this.tags,
      status: 3
    }
    this.loading = true
    const { success } = await Api.editUniqueInfo(param)
    this.loading = false
    if (success) {
      message.success('保存成功')
      this.getUniqueInfo()
    }
  }

  @action
  changeOpenStatus = bool => {
    this.openStatus = bool
  }

  @action
  prohibitCheck = index => async content => {
    if (!content) {
      this.prohibit[index] = ''
      return
    }
    const { data, success } = await Api.prohibitCheck({
      content,
      sceneList: ['违规词', '极限词', '套餐案例标题', '套餐案例全局'],
      productName: '婚礼纪'
    })

    if (success) {
      this.prohibit[index] = (data.wordProhibitVOList || [])
        .map(item => item.keyword)
        .join('、')
    } else {
      message.error('违规词检测异常')
    }
  }
}

export default Store
